var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.998,
    height: 62.998,
    viewBox: "0 0 62.998 62.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9372.5,13234a31.406,31.406,0,1,1,12.261-2.476A31.3,31.3,0,0,1,9372.5,13234Zm-14.3-34.87a3.379,3.379,0,0,0-2.549,5.6l9.124,10.492a3.383,3.383,0,0,0,4.77.336,3.655,3.655,0,0,0,.5-.531l18.874-18.879a3.381,3.381,0,1,0-4.782-4.779l-16.656,16.656-6.723-7.731A3.378,3.378,0,0,0,9358.2,13199.13Z",
    transform: "translate(-9341.002 -13171.002)",
    fill: "#96e0c0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.d595023b29f3fdb6521153545cc79767.svg";
export { ForwardRef as ReactComponent };